module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle3"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch11",
      "id": "rch11"
    }
  }, [_c('b', [_vm._v("Know Your Butts")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub2an"
  }, [_c('b', [_vm._v("Lots of things that have nothing to do with rear ends are known as butts. Here’s a whole load of non-butt butts for you to ponder.")])]), _vm._v(" "), _c('p', {
    staticClass: "sub2an"
  }, [_vm._v("(Special thanks to BRI reader Seymour Butts for sending them in.)")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p40-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("A mouth-watering butt roast")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Butt Roast:")])]), _vm._v(" A particular cut of pork taken from the pig’s…shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Boston Butt:")])]), _vm._v(" This variation on the butt roast originated in Boston.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Butt Rubbing:")])]), _vm._v(" The practice of rubbing spices and other dry seasonings into a butt roast. (For Boston butts, the practice would be known as Boston butt rubbing.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Butt Log:")])]), _vm._v(" A log cut from the lowest, widest part of a tree trunk, just above the stump, or “butt.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Buttle:")])]), _vm._v(" A verb that describes what butlers do: They “buttle.”")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p40-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("The inventor of Scrabble, Alfred Butts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Butts, Alfred Mosher:")])]), _vm._v(" The unemployed American architect who invented the board game Scrabble in 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("David Bensusan-Butt:")])]), _vm._v(" A wartime British civil servant and author of the Butt Report.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Water Butt:")])]), _vm._v(" The British name for a rain barrel.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Major Archibald Butt, the biggest butt that went down with the "), _c('i', [_vm._v("Titanic")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Major Butt:")])]), _vm._v(" A military aide to presidents Teddy Roosevelt and William Howard Taft, Archibald Butt was present when Taft threw out the first presidential baseball in 1910. He was also onboard the "), _c('i', [_vm._v("Titanic")]), _vm._v(" when it struck an iceberg on April 14, 1912, and he went down with the ship.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("The Butt Memorial Bridge:")])]), _vm._v(" A bridge in Augusta, Georgia, built in 1914 and dedicated to the memory of Major Butt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Sackbut:")])]), _vm._v(" A style of trombone popular during the Renaissance and Baroque eras.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Butt Rot:")])]), _vm._v(" When the butt of a living tree suffers from a fungal infection, it’s said to have “butt rot.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_vm._v("The Butt Report:")])]), _vm._v(" A secret World War II report critical of British bombers for an inability to hit their targets. The Butt Report spurred changes in tactics and technology that vastly improved bomber accuracy.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("URANUS SPINS ON ITS SIDE.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425576a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/018_Chapter11.vue
// module id = 111
// module chunks = 0